export default "__VITE_PUBLIC_ASSET__8d45d224__"